<template>
  <div class="flex-shrink-0 relative w-full mb-10 lg:w-80 lg:mb-0">
    <div class="relative pb-67% bg-gray-200 lg:pb-65%">
      <a
        :href="
          resizeImage(image, {
            w: 1400,
            h: 1000,
            fit: 'max',
            fm: 'jpg',
          })
        "
        class="dynamic-zoom block"
        v-if="image && zoom"
      >
        <picture>
          <source
            media="(min-width:1024px)"
            :srcset="
              resizeImage(image, {
                w: 200,
                h: 130,
                fit: 'crop-center',
              })
            "
            type="image/webp"
          />
          <source
            media="(min-width:768px)"
            :srcset="
              resizeImage(image, {
                w: 650,
                h: 640,
                fit: 'crop-center',
              })
            "
            type="image/webp"
          />
          <source
            media="(min-width:640px)"
            :srcset="
              resizeImage(image, {
                w: 700,
                h: 470,
                fit: 'crop-center',
              })
            "
            type="image/webp"
          />
          <source
            media="(min-width:320px)"
            :srcset="
              resizeImage(image, {
                w: 560,
                h: 357,
                fit: 'crop-center',
              })
            "
            type="image/webp"
          />
          <img
            :src="image"
            :alt="name"
            width="500"
            height="500"
            class="absolute w-full !h-full object-cover transition-opacity duration-300 opacity-0"
            loading="lazy"
            @load="imageLoaded($event.target)"
          />
        </picture>
      </a>

      <picture v-else-if="image">
        <source
          media="(min-width:1024px)"
          :srcset="
            resizeImage(image, {
              w: 200,
              h: 130,
              fit: 'crop-center',
            })
          "
          type="image/webp"
        />
        <source
          media="(min-width:768px)"
          :srcset="
            resizeImage(image, {
              w: 650,
              h: 640,
              fit: 'crop-center',
            })
          "
          type="image/webp"
        />
        <source
          media="(min-width:640px)"
          :srcset="
            resizeImage(image, {
              w: 700,
              h: 470,
              fit: 'crop-center',
            })
          "
          type="image/webp"
        />
        <source
          media="(min-width:320px)"
          :srcset="
            resizeImage(image, {
              w: 560,
              h: 357,
              fit: 'crop-center',
            })
          "
          type="image/webp"
        />
        <img
          :src="image"
          :alt="name"
          width="500"
          height="500"
          class="absolute w-full !h-full object-cover transition-opacity duration-300 opacity-0"
          loading="lazy"
          @load="imageLoaded($event.target)"
        />
      </picture>
    </div>
  </div>
</template>

<script>
import { resizeImage } from '@/libraries/Helpers'

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    zoom: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const imageLoaded = (target) => {
      target.classList.remove('opacity-0')
    }

    return {
      resizeImage,
      imageLoaded,
    }
  },
}
</script>
